
const estadoInicial = {
    productos: [
        {id: 1, nombre: 'Evaluación de barreras y estructuras'},
        {id: 2, nombre: 'Depreción y transtorno de la marcha.'},
        {id: 3, nombre: 'Apoyo a la familia.'},
        {id: 4, nombre: 'Terapia funcional.'},
        {id: 5, nombre: 'Valoración dietética.'},
        {id: 6, nombre: 'Revisión de medicamentos.'}
    ],

    carrito: []
}

// Reducer es una funcion que se encarga de administar el estado global de nuestra app
const reducer = (estado = estadoInicial, accion) => {
    switch(accion.type){
        case 'AGREGAR_PRODUCTO_AL_CARRITO':
            const {nombre, idProductoAAgregar} = accion;

            if(estado.carrito.length === 0){
                return {
                    ...estado,
                    carrito: [{id: idProductoAAgregar, nombre: nombre, cantidad: 1}]
                }
            } else {
                //De otra forma tenemos que revisar que el carrito no tenga ya el producto que queremos agregar
                // Si ya lo tiene entonces queremos actualizar su valor
                // Si no tiene el producto entonces lo agregamos
    
                // Para poder editar el arreglo tenemos que clonarlo
                const nuevoCarrito = [...estado.carrito];
    
                // Comprobar si el carrito ya tienen el ID del producto que queremos agregar con filter
                const yaEstaEnCarrito = nuevoCarrito.filter((productoDeCarrito) => {
                    return productoDeCarrito.id === idProductoAAgregar
                }).length >0;

                // Si ya tienen el producto entonces lo tenemos que actualizar
            if(yaEstaEnCarrito){
                // Para ello tenemos que buscarlo, obtener su posicion en el arreglo
                // Y en base a su posicion ya actualizamos el valor
                nuevoCarrito.forEach((productoDeCarrito, index) => {
                    if(productoDeCarrito.id === idProductoAAgregar){
                        const cantidad = nuevoCarrito[index].cantidad;
                        nuevoCarrito[index] = {
                            id: idProductoAAgregar, 
                            nombre: nombre, 
                            cantidad: cantidad +1
                        }
                    }
                });
                // De otra forma entonces agregamos el producto al arreglo
            } else {
                nuevoCarrito.push(
                    {
                        id: idProductoAAgregar,
                        nombre: nombre,
                        cantidad: 1
                    }
                );
            }
            return {
                ...estado,
                carrito: nuevoCarrito
            }
        }
            
        default:
            return estado;
    }
    
}

export default reducer;